module.exports = __webpack_public_path__ + "img/dzjy3.989c4ede.jpg";